import { api } from "jiffy-api";
import { store } from "jiffy-store";
import MadeStore from "components/jiffy/vue-product-details-print/store/store";
import { MODES } from "components/jiffy/vue-product-details-print/misc/constants";
import {
  isFlashPdp,
  getPageSourceParam
} from "components/jiffy/product-details/customizable-made-page-utils";

const UPDATE_INTERVAL = 10000;

const $getSameDayTitles = () => document.querySelectorAll(".js-qty-row-same-day-title");
const $getSameDayVariants = () => document.querySelectorAll(".js-qty-row-same-day-stock");
const $getQtyFormGroups = () => document.querySelectorAll(".js-qty-form-group");
const $getProductPageContainer = () => document.getElementById("product-page-container");

const getStockData = () => {
  const { productId } = $getProductPageContainer().dataset;
  return api.printOnDemand.getFlashStock({ slug: productId }, { source: getPageSourceParam() });
};

const hideSameDayInfo = () => {
  $getSameDayTitles().forEach(el => el.classList.add("hidden"));
  $getSameDayVariants().forEach(el => el.classList.add("hidden"));
};

const fillFlashDedicatedGrid = inventory => {
  hideSameDayInfo();
  $getQtyFormGroups().forEach($group => {
    const { variantId } = $group.dataset;
    if (inventory?.[variantId]) {
      $group.querySelector(".js-qty-row-same-day-badge").classList.remove("hidden");
    }
  });
};

const fillMadePdp = (inventory, earliestDelivery) => {
  $getSameDayVariants().forEach($el => {
    const { variantId } = $el.dataset;
    const $amountEl = $el.querySelector(".js-qty-row-same-day-amount");
    const variantAmount = inventory?.[variantId];
    const titleText = earliestDelivery === "next_day" ? "Next Day Stock" : "Same Day Stock";
    if (variantAmount !== undefined) {
      $amountEl.innerText = variantAmount;
      $el
        .closest(".js-product-details-quantity-form-row-item")
        .querySelector(".js-qty-row-same-day-title-text").innerText = titleText;
      $el
        .closest(".js-product-details-quantity-form-row-item")
        .querySelector(".js-qty-row-same-day-title")
        .classList.remove("hidden");
      $el.classList.toggle("product-details-quantity-form-row__same-day--empty", !variantAmount);
    }
    $el.classList.toggle("hidden", variantAmount === undefined);
  });
};

const startUpdateTimer = () => {
  if (window.flashUpdateTimer) {
    clearInterval(window.flashUpdateTimer);
  }
  window.flashUpdateTimer = setInterval(updateFlashStock, UPDATE_INTERVAL);
};

const updateFlashStock = async () => {
  const pageMode = MadeStore.getters["app/mode"];
  if (pageMode === MODES.BLANKS) {
    hideSameDayInfo();
    return;
  }
  if (isFlashPdp()) {
    store.pdp.change({
      isFlashPdpLoading: true
    });
  }

  const { inventory, earliest_delivery: earliestDelivery } = await getStockData();

  if (isFlashPdp()) {
    window.inventory = inventory;
    store.pdp.change({
      isSettingGridInventory: true,
      isFlashPdpLoading: false
    });
    store.ui.change({ inventoryLoaded: true, inventoryLoading: false });
    fillFlashDedicatedGrid(inventory);
  } else {
    fillMadePdp(inventory, earliestDelivery);
  }

  startUpdateTimer();
};

export default updateFlashStock;
